import React from "react";
import * as S from "./sections";

// Map section keys (from spec/shuffle config) to React components.
// This enables modular reordering for landing pages.
const REGISTRY = {
  hero: S.Hero,
  trust_strip: S.TrustStrip,
  guided_choice_section: S.GuidedChoice,
  services_overview: S.ServicesOverview,
  benefit_support: S.BenefitSupport,
  additional_services: S.AdditionalServices,
  booking_section: S.BookingSection,
  about_sarah: S.AboutSarah,
  how_it_works: S.HowItWorks,
  why_choose_daisy_does: S.WhyChoose,
  pricing_preview: S.PricingPreview,
  contact_options_section: S.ContactOptions,
  testimonials: S.Testimonials,
  disclaimer: S.Disclaimer,
  final_cta: S.FinalCTA,
  contact_form: S.ContactForm,

  // Services page
  services_hero: S.ServicesHero,
  service_cards: S.ServiceCards,
  household_admin: S.HouseholdAdminBlock,
  elderly_support_block: S.ElderlySupportBlock,
  family_support_block: S.FamilySupportBlock,
  applications_forms_block: S.ApplicationsFormsBlock,
  home_services_block: S.HomeServicesBlock,

  // Benefit page
  benefit_hero: S.BenefitHero,
  benefit_types: S.BenefitTypes,
  how_sarah_helps: S.HowSarahHelps,
  documents_needed: S.DocumentsNeeded,
  benefit_process: S.BenefitProcess,

  // Elderly page
  elderly_hero: S.ElderlyHero,

  // About page
  about_hero: S.AboutHero,
  values: S.Values,
  why_started: S.WhyStarted,

  // Pricing page
  pricing_hero: S.PricingHero,
  pricing_cards: S.PricingCards,
  package_options: S.PackageOptions,
  pricing_note: S.PricingNote,

  // Contact page
  contact_hero: S.ContactHero,
  contact_reassurance: S.ContactReassurance,
};

const SectionRenderer = ({ sections }) => (
  <>
    {sections.map((key, i) => {
      const Cmp = REGISTRY[key];
      if (!Cmp) return null;
      return <Cmp key={`${key}-${i}`} />;
    })}
  </>
);

export default SectionRenderer;
